/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Lucio API
 * Lucio AI Outlook Add-in Backend API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  ErrorResponse,
  PostInboxContextEmails200Item,
  PostInboxContextEmailsBody,
  PostInboxFetch200,
  PostInboxFetchBody,
  ValidationErrorResponse
} from '../lucioAPI.schemas';

import { customInstance } from '../../mutator';




/**
 * Retrieve paginated inbox emails with optional search and context email IDs.
 * @summary Fetch inbox emails
 */
export const postInboxFetch = (
    postInboxFetchBody: PostInboxFetchBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostInboxFetch200>(
      {url: `/inbox/fetch`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postInboxFetchBody, signal
    },
      );
    }
  


export const getPostInboxFetchMutationOptions = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInboxFetch>>, TError,{data: PostInboxFetchBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postInboxFetch>>, TError,{data: PostInboxFetchBody}, TContext> => {

const mutationKey = ['postInboxFetch'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postInboxFetch>>, {data: PostInboxFetchBody}> = (props) => {
          const {data} = props ?? {};

          return  postInboxFetch(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostInboxFetchMutationResult = NonNullable<Awaited<ReturnType<typeof postInboxFetch>>>
    export type PostInboxFetchMutationBody = PostInboxFetchBody
    export type PostInboxFetchMutationError = ValidationErrorResponse | ErrorResponse

    /**
 * @summary Fetch inbox emails
 */
export const usePostInboxFetch = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInboxFetch>>, TError,{data: PostInboxFetchBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postInboxFetch>>,
        TError,
        {data: PostInboxFetchBody},
        TContext
      > => {

      const mutationOptions = getPostInboxFetchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Retrieve specific emails by their IDs for conversation context.
 * @summary Fetch context emails
 */
export const postInboxContextEmails = (
    postInboxContextEmailsBody: PostInboxContextEmailsBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostInboxContextEmails200Item[]>(
      {url: `/inbox/context-emails`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postInboxContextEmailsBody, signal
    },
      );
    }
  


export const getPostInboxContextEmailsMutationOptions = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInboxContextEmails>>, TError,{data: PostInboxContextEmailsBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postInboxContextEmails>>, TError,{data: PostInboxContextEmailsBody}, TContext> => {

const mutationKey = ['postInboxContextEmails'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postInboxContextEmails>>, {data: PostInboxContextEmailsBody}> = (props) => {
          const {data} = props ?? {};

          return  postInboxContextEmails(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostInboxContextEmailsMutationResult = NonNullable<Awaited<ReturnType<typeof postInboxContextEmails>>>
    export type PostInboxContextEmailsMutationBody = PostInboxContextEmailsBody
    export type PostInboxContextEmailsMutationError = ValidationErrorResponse | ErrorResponse

    /**
 * @summary Fetch context emails
 */
export const usePostInboxContextEmails = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInboxContextEmails>>, TError,{data: PostInboxContextEmailsBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postInboxContextEmails>>,
        TError,
        {data: PostInboxContextEmailsBody},
        TContext
      > => {

      const mutationOptions = getPostInboxContextEmailsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    